import moment from 'moment';

export const dateForm = (date) => {
   if (!date) return '';
   let d;
   if (date instanceof window.Date) {
      // Déjà un objet Date : utiliser directement les méthodes locales
      d = date;
   } else {
      const str = String(date).trim();
      if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
         // Chaîne "YYYY-MM-DD" : parser en temps LOCAL pour éviter le décalage UTC
         const [y, m, day] = str.substring(0, 10).split('-').map(Number);
         d = new window.Date(y, m - 1, day);
      } else {
         d = new window.Date(date);
      }
   }
   const fullYear = d.getFullYear();
   const month = String(d.getMonth() + 1).padStart(2, '0');
   const day = String(d.getDate()).padStart(2, '0');
   return `${fullYear}-${month}-${day}`;
};

// Format une date (YYYY-MM-DD ou YYYY-M-D) en format français JJ/MM/AAAA
export const formatDateFR = (dateStr) => {
   if (!dateStr) return '';
   const parts = String(dateStr).split(' ')[0].split('-');
   if (parts.length !== 3) return dateStr;
   const [year, month, day] = parts;
   return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
};

// Convertit une heure AM/PM (ex: "08:00AM", "06:00 PM") en format 24h ("08:00", "18:00")
export const formatTime24h = (timeStr) => {
   if (!timeStr) return '';
   // Normalise : enlève les espaces autour de AM/PM
   const cleaned = String(timeStr).trim().replace(/\s+/g, ' ');
   // Détecte si c'est déjà en 24h (pas de AM/PM)
   if (!/AM|PM/i.test(cleaned)) return cleaned;

   // Extrait les parties (avec ou sans espace : "08:00AM" ou "08:00 AM")
   const match = cleaned.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)$/i);
   if (!match) return cleaned;

   let hours = parseInt(match[1], 10);
   const minutes = match[2];
   const period = match[4].toUpperCase();

   if (period === 'AM') {
      if (hours === 12) hours = 0;
   } else {
      if (hours !== 12) hours += 12;
   }

   return `${String(hours).padStart(2, '0')}:${minutes}`;
};

// Calcule la durée entre deux heures 24h (ex: "08:00" et "11:30" → "3h30")
export const calcDuration = (startTime, endTime) => {
   const start = formatTime24h(startTime);
   const end = formatTime24h(endTime);
   if (!start || !end) return null;
   const [sh, sm] = start.split(':').map(Number);
   const [eh, em] = end.split(':').map(Number);
   const startMin = sh * 60 + sm;
   let endMin = eh * 60 + em;
   if (endMin < startMin) endMin += 24 * 60;
   const diff = endMin - startMin;
   if (diff <= 0) return null;
   const hours = Math.floor(diff / 60);
   const minutes = diff % 60;
   if (hours === 0) return `${minutes} min`;
   if (minutes === 0) return `${hours}h`;
   return `${hours}h${String(minutes).padStart(2, '0')}`;
};

export const getLocation = (item, boardingAndDroppingPoint) => {
   const drop_location_id = item?.drop_location_id;
   const pick_location_id = item?.pick_location_id;
   const pick = boardingAndDroppingPoint.find(
      (pickLocation) => pickLocation?.id === pick_location_id
   );
   const drop = boardingAndDroppingPoint.find(
      (dropLocation) => dropLocation?.id === drop_location_id
   );

   if (pick && drop) {
      return `${pick?.name} - ${drop?.name}`;
   } else {
      return 'Chargement...';
   }
};

export const getMaxValue = (array) => {
   return array?.reduce(function (prev, current) {
      return Math.max(prev, current.adult_fair);
   }, 0);
};

export const getMinValue = (array) => {
   var len = array.length,
      min = Infinity;
   while (len--) {
      if (Number(array[len].adult_fair) < min) {
         min = Number(array[len].adult_fair);
      }
   }
   return min;
};

export const compareTime = (busObj) => {
   const { busType, arrivalTime, departureTime, filterBus, durationArray } =
      busObj;
   const arrivalArray = [];
   const departureArray = [];
   const array = [];
   const format = 'HH:mm';

   if (arrivalTime) {
      for (let i = 0; i < durationArray?.length; i++) {
         const start = durationArray[i].start;
         const end = durationArray[i].end;
         const startTime = moment(start, format);
         const endTime = moment(end, format);
         for (let j = 0; j < filterBus?.length; j++) {
            const item = filterBus[j];
            const Time = formatTime24h(item.end_time);
            const arrivalTime = moment(Time, format);
            if (arrivalTime.isBetween(startTime, endTime)) {
               arrivalArray.push(item);
            }
         }
      }
      return arrivalArray;
   } else if (departureTime) {
      for (let i = 0; i < durationArray?.length; i++) {
         const start = durationArray[i].start;
         const end = durationArray[i].end;
         const startTime = moment(start, format);
         const endTime = moment(end, format);
         for (let j = 0; j < filterBus?.length; j++) {
            const item = filterBus[j];
            const Time = formatTime24h(item.start_time);
            const arrivalTime = moment(Time, format);
            if (arrivalTime.isBetween(startTime, endTime)) {
               departureArray.push(item);
            }
         }
      }
      return departureArray;
   } else if (busType) {
      for (let i = 0; i < durationArray?.length; i++) {
         const item = durationArray[i];
         for (let j = 0; j < filterBus?.length; j++) {
            const element = filterBus[j];
            if (element.fleet_id === item) {
               array.push(element);
            }
         }
      }
      return array;
   }
};

export const convertTime12to24 = (time12h) => {
   const [time, modifier] = time12h.split(' ');

   let [hours, minutes] = time.split(':');

   if (hours === '12') {
      hours = '00';
   }

   if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
   }
   return `${hours}:${minutes}`;
};

export const getPicLocation = (location, values) => {
   return location.findIndex((locationName) => {
      return String(locationName.id) === String(values.pick_location);
   });
};

export const getDropLocation = (location, values) => {
   return location.findIndex((locationName) => {
      return String(locationName.id) === String(values.drop_location);
   });
};

export const isRegurnDateValid = (date) => date?.split('-').includes('NaN');

export const toUpperFirst = (string) =>
   string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase();

export const FirstLetterUppercase = (text) => {
   const arr = text.split(' ');

   for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
   }

   const str2 = arr.join(' ');
   return str2;
};

const api_url = `${process.env.REACT_APP_API_MODULE_DOMAIN}/website/seetings`;

export const getSettingsData = async () => {
   const response = await fetch(api_url);
   var data = await response.json();
   return data;
};

export const busType = (fleet, fleetId) => {
   const result = fleet?.find((item) => item?.id === fleetId);
   return result?.type;
};
